import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const QuickSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;
    const maxTimer = Math.ceil(Math.log(values.length + 1));

    const partition = (l, r, timer) => {
      const pivot = values[r];
      let j = l - 1;
      for (let i = l; i < r; i++) {
        countIterations(i);
        if (values[i] < pivot) {
          j++;
          [values[i], values[j]] = [values[j], values[i]];
          [ids[i], ids[j]] = [ids[j], ids[i]];
          document.getElementById(ids[i]).style.transform = `translateX(${i * 11}px)`;
          document.getElementById(ids[j]).style.transform = `translateX(${j * 11}px)`;
        }
      }
      [values[r], values[j + 1]] = [values[j + 1], values[r]];
      [ids[r], ids[j + 1]] = [ids[j + 1], ids[r]];

      schedule(() => {
        document.getElementById(ids[j + 1]).childNodes[1].style.backgroundColor = 'black';
        schedule(() => {
          document.getElementById(ids[j + 1]).childNodes[1].style.backgroundColor = color;
        }, speed * 6 - 10);
        document.getElementById(ids[r]).style.transform = `translateX(${r * 11}px)`;
        document.getElementById(ids[j + 1]).style.transform = `translateX(${(j + 1) * 11}px)`;
      }, speed * timer * 6);

      return j + 1;
    };

    const quickSort = (l, r, timer) => {
      if (l < r) {
        const ind = partition(l, r, timer);
        quickSort(l, ind - 1, timer - 1);
        quickSort(ind + 1, r, timer - 1);
      }
    };

    quickSort(0, values.length - 1, maxTimer);

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, 6 * speed * (1 + maxTimer) + 100);
  };

  useEffect(() => {
    if (myState.algorithm === 'quick' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default QuickSort;
